import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs';
import { StudyDicomInfo } from 'src/app/models/Study/study.model';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { StudiesFacade } from 'src/app/shared-new/store/studies/studies.facade';
import { StudyState } from '../../shared-new/store/studies/studies.reducer';
import { DateParserFormatter } from '../../utils/helper/date-parser-formatter';

@Component({
  selector: 'app-sale-study-files-popup',
  templateUrl: './sale-study-files-popup.component.html',
  styleUrls: ['./sale-study-files-popup.component.scss'],
})
export class SaleStudyFilesPopupComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() public data: any;

  displayedColumns: string[] = [
    'entry',
    'accNo',
    'saleName',
    'type',
    'hip',
    'horseName',
    'sire',
    'dam',
    //'dob',
    'microchip',
    'consignor',
    'studyDate',
    //'actions',
  ];
  hipConfirmed = false;
  showTable = false;
  dataSource: StudyDicomInfo[] = [];
  tabStatus$ = this.studyFacade.tabStatus$;
  initialFlagsSnapshot: Partial<StudyState>;
  studyFileRows$ = this.studyFacade.studyFileRows$;
  public lotOrHipText: string;
  constructor(
    public readonly modal: NgbActiveModal,
    private dateParserFormatter: DateParserFormatter,
    private studyFacade: StudiesFacade
  ) {
    super();
  }




  ngOnInit(): void {
    this.studyFacade.resetActivityState();
  }

  async closeModal() {
    const changed = await this.studyFacade.hasStudyStateChanged();
    this.modal.dismiss(changed);
  }
}
